import {
  Box,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@ublend-npm/aulaui-core';
import React, { useMemo } from 'react';
import { createStyles } from './ConversionDetails.styles';
import useIsOverflowing from '@app/hooks/useIsOverflowing';

type ConversionDetailsProps = {
  currentTitle: string;
  convertedExtensionTitle?: string | null;
  parentAssignmentTitle?: string | null;
};

const ConversionDetails = ({
  currentTitle,
  convertedExtensionTitle = null,
  parentAssignmentTitle = null,
}: ConversionDetailsProps) => {
  // Get the styles
  const theme = useTheme();
  const styles = createStyles(theme as any);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const metaData = useMemo(
    () => ({
      existingAssignment: {
        title: 'Existing assignment:',
        value: `"${currentTitle}"`,
      },
      convertedExtension: {
        title: 'Will be turned into an extension called:',
        value: `"${convertedExtensionTitle}"`,
      },
      parentAssignment: {
        title: 'As a part of the assignment:',
        value: parentAssignmentTitle
          ? `"${parentAssignmentTitle}"`
          : 'Select a destination assignment above',
      },
    }),
    [currentTitle, convertedExtensionTitle, parentAssignmentTitle]
  );

  return (
    <Box>
      {Object.values(metaData).map((item, index) => (
        <Box key={item.title} sx={styles.metaDataContainer}>
          <Typography sx={styles.main}>{item.title}</Typography>
          <MetaValue
            key={`${index}-${item.value}`}
            value={item.value}
            isMobile={isMobile}
            sx={{ ...styles.main, ...styles.subtitle }}
          />
        </Box>
      ))}
    </Box>
  );
};

const MetaValue = ({ value, sx, isMobile }) => {
  const [textRef, isOverflowing] = useIsOverflowing<HTMLDivElement>();
  return (
    <Tooltip
      title={value}
      disableInteractive
      disableHoverListener={!isOverflowing || isMobile}
      disableFocusListener={!isOverflowing || isMobile}
      disableTouchListener={!isOverflowing || isMobile}
    >
      <Box ref={textRef} sx={sx}>
        {value}
      </Box>
    </Tooltip>
  );
};

export default React.memo(ConversionDetails);
